import { forwardRef, type Ref, type SVGProps } from "react";

function SvgMapPaper(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="square"
        strokeLinejoin="round"
        d="M5.667 3.333v8.333m4.666-7.333v8.333m-8.666-1.222V5.03c0-.564.355-1.068.886-1.257l2.7-.96c.268-.095.561-.102.835-.018L9.913 3.96c.273.084.566.077.835-.019l1.805-.642a1.333 1.333 0 0 1 1.78 1.257v6.414c0 .564-.355 1.067-.886 1.256l-2.7.96a1.34 1.34 0 0 1-.834.019l-3.825-1.166a1.33 1.33 0 0 0-.836.02l-1.805.641a1.333 1.333 0 0 1-1.78-1.256Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgMapPaper);
export default ForwardRef;
